import {
  BrowserCacheLocation,
  InteractionType,
  LogLevel,
  PublicClientApplication,
  type Configuration,
  type RedirectRequest
} from '@azure/msal-browser';

import { environment } from '@env/environment';

/** MSAL logger sink. Kept quiet by default; switch on when debugging sign-in. */
export function loggerCallback(_logLevel: LogLevel, _message: string): void {
  // no-op
}

export const msalConfiguration: Configuration = {
  auth: {
    clientId: environment.msalConfig.auth.clientId,
    authority: environment.msalConfig.auth.authority,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage
  },
  system: {
    // Disables the WAM/platform broker. Renamed from `allowNativeBroker`
    // in msal-browser v4; same effect.
    allowPlatformBroker: false,
    loggerOptions: {
      loggerCallback,
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false
    }
  }
};

/**
 * The MSAL client the app authenticates with.
 *
 * msal-react takes the
 * instance directly, and `initialize()` must have resolved before any other
 * call - see `src/main.tsx`, which awaits it before rendering.
 */
export const msalInstance = new PublicClientApplication(msalConfiguration);

/**
 * Scopes for the portal API.
 *
 * These are attached by the fetch wrapper in core/api/http.ts, via a
 * `protectedResourceMap`. React has no DI interceptor chain, so the same map
 * is consulted by the fetch wrapper in `src/core/api/http.ts`.
 */
export const protectedResourceMap = new Map<string, string[]>([
  [environment.apiConfig.uri, environment.apiConfig.scopes]
]);

/** Redirect based sign-in, used by the route guard and the toolbar. */
export const loginRequest: RedirectRequest = {
  scopes: [...environment.apiConfig.scopes]
};

export const guardInteractionType = InteractionType.Redirect;

/** Microsoft Graph is a separate resource with its own scopes. */
export const graphRequestScopes = ['https://graph.microsoft.com/.default'];
